<script lang="ts">
    import {BookmarkIcon} from "../../Data/Layout/Header";
    import FeatherIcon from "svelte-feather-icon";
</script>
<ul class="m-t-5">
    {#each BookmarkIcon as bookmarkItem}
        <li class="add-to-bookmark">
            <FeatherIcon class="bookmark-icon"  icon={bookmarkItem.Icon}/>{bookmarkItem.Name}
            <span class="pull-right">
                <FeatherIcon icon="star" />
            </span>
        </li>
    {/each}
</ul>